/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/9/1
 * @updateTime 2021/9/1
 * @decription
 * @namespace 【】
 */
export default {
    name: '',
    // 混入
    mixins: [],
    // 依赖组件
    components: {},
    // 参数
    props: {
        // 标题
        title: String,
        // 数据
        data: Array,
        // 是否禁用
        disabled: Boolean
    },
    // 数据
    data() {
        return {
            // 当前作用域变量
            scope: {
                // 类名前缀
                prefixCls: 'fd-ac-tab-module'
            },
        };
    },
    // 计算属性
    computed: {
        /**
         * 容器类名
         * @returns {Array<String>} 类名数组
         * */
        wrapClasses() {
            return [
                this.scope.prefixCls
            ];
        }
    },
    // 监听
    watch: {},
    // 创建完成
    created() {
    },
    // 组件激活
    activated() {
    },
    // 组件初始化完成
    mounted() {
    },
    // 组件失去激活
    deactivated() {
    },
    // 销毁之前
    beforeDestroy() {
    },
    // 方法
    methods: {
        /**
         * 信息项点击事件
         * @param {Object} item 数据信息项
         * @returns {void}
         * */
        eClickItem(item) {
            // 分发点击事件
            this.$emit('click', item);
        }
    }
};
